import { APICore } from "./apiCore";

const api = new APICore()

function getContactos(params:any): any{
    const baseUrl = "/contactos"
    return api.get(baseUrl,params)
}

function getContacto(id:String): any{
    const baseUrl = `/contactos/${id}`
    return api.get(baseUrl,{})
}

function updateContacto(params:any): any{
    const baseUrl = "/contactos"
    return api.update(baseUrl,params)
}

export {getContactos,getContacto,updateContacto}
